<template>
    <div ref="scrollPane" class="tags-view-wrapper" id="tags-view-container">
        <div class="all-tags-inner" v-if="isShowTabs">
            <router-link
                v-for="tag in visitedViews.slice(0, maxLength)"
                ref="tag"
                :class="isActive(tag)?'active':''"
                :to="{ path: tag.path, query: tag.query, fullPath: tag.fullPath }"
                :key="tag.fullPath" tag="span" class="tags-view-item-all"
                @click.middle="closeSelectedTag(tag)"
                @contextmenu.prevent="openMenu(tag,$event)">
                <span class="tags-view-item">
                    {{tag.resourceName}}{{tag.orderNo}}
                    <span class="el-icon-close" @click.prevent.stop="closeSelectedTag(tag)"></span>
                </span>
            </router-link>
            <!-- 更多 -->
            <el-dropdown trigger="click" class="more-dropdown" v-if="visitedViews.length > maxLength">
                <span class="el-dropdown-link">
                    <el-button type="text" class="icon iconfont icon-button icon-topbar_more"></el-button>
                </span>
                <template #dropdown>
                    <el-dropdown-menu>
                        <el-dropdown-item
                            v-for="(item, index) in allTags"
                            :key="index"
                            @click="handleClickDropdownItem(item, index)"
                            class="tag-item">
                            {{item.resourceName}}
                            <!-- <span class="el-icon-close" @click.prevent.stop="closeSelectedTag(item)"></span> -->
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </template>
            </el-dropdown>
        </div>
        <!-- <ul v-show="visible" :style="{left:left+'px'}" class="contextmenu">
            <li @click="refreshSelectedTag(selectedTag)">刷新</li>
            <li @click="closeSelectedTag(selectedTag)">关闭</li>
            <li @click="closeOthersTags">关闭其他</li>
            <li @click="closeAllTags">全部关闭</li>
        </ul> -->
    </div>
</template>

<script>
import tagsViewHook from './tagsView';
export default {
    props: {
        isShowTabs: {
            type: Boolean,
            default: true
        },
        indexPage: {
            type: String,
            default: '/index'
        },
        // 可展示的最大tag数
        maxLength: {
            type: Number,
            default: 6
        },
    },
    data () {
        return {
        };
    },
    setup (props, ctx) {
        const {
            visible,
            left,
            selectedTag,
            closeAllTag,
            allTags,
            flatResourceSearch,
            visitedViews,
            isActive,
            handleClickDropdownItem,
            closeSelectedTag,
            openMenu
        } = tagsViewHook(props, ctx);
        return {
            visible,
            left,
            selectedTag,
            closeAllTag,
            allTags,
            flatResourceSearch,
            visitedViews,
            isActive,
            handleClickDropdownItem,
            closeSelectedTag,
            openMenu
        };
    }
};
</script>

<style lang="less" scoped>
@import url('./tagsView.less');
</style>
